export const BASE_AI_TOOL_UI_STYLE_BUNDLE = {
  id: "base-ai-tool-ui",
  cssText: `
.tool-bubble-default {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tool-bubble-default-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.tool-bubble-default-title {
  color: var(--text-primary);
  font-size: var(--font-size-sm);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.tool-bubble-default-status {
  color: var(--text-secondary);
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.tool-bubble-default-pre {
  margin: 0;
  padding: 10px 12px;
  border-radius: var(--radius-md);
  background: var(--bg-card);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: var(--text-primary);
  overflow: auto;
  font-size: var(--font-size-sm);
  white-space: pre-wrap;
  word-break: break-word;
  backdrop-filter: blur(8px);
}

/* Generic spinner used by tool-owned UIs */
.function-call-simple-spinner {
  display: inline-block;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-top-color: transparent;
  flex-shrink: 0;
  animation: function-call-simple-spin 0.8s linear infinite;
  vertical-align: middle;
}

@keyframes function-call-simple-spin {
  to {
    transform: rotate(360deg);
  }
}
  `.trim(),
};
